import script from "./WordListExpressionsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./WordListExpressionsForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__